import React from "react";
import NavBar from "../components/NavBar";

const OrbisLinesSupportPage = ({ language, onLanguageChange, t }) => {
  const contactItems = t("orbisSupport.contactDetails.details") || [];
  const issues = t("orbisSupport.commonIssues.items") || [];

  return (
    <div
      className="page foody-page trains-page support-page"
      id="orbis-support-top"
    >
      <NavBar
        language={language}
        onLanguageChange={onLanguageChange}
        items={[{ href: "/apps/orbislines", label: t("orbisSupport.back") }]}
      />

      <main className="foody-main">
        <section className="foody-hero support-hero">
          <div className="foody-hero-copy">
            <span className="support-pill">{t("orbisSupport.badge")}</span>
            <h1>{t("orbisSupport.hero.title")}</h1>
            <p>
              {t("orbisSupport.hero.descPrefix")} <strong>Orbis Lines</strong>?{" "}
              {t("orbisSupport.hero.descSuffix")}
            </p>
            <p className="support-muted">{t("orbisSupport.hero.updatedAt")}</p>
          </div>
        </section>

        <section className="foody-section">
          <div className="foody-grid support-grid">
            <article className="foody-card">
              <h3>{t("orbisSupport.contact.title")}</h3>
              <p>{t("orbisSupport.contact.emailLabel")}</p>
              <p>
                <a href="mailto:support-orbislines@wodaslabs.com">
                  support-orbislines@wodaslabs.com
                </a>
              </p>
              <p className="support-muted">
                {t("orbisSupport.contact.responseTime")}
              </p>
            </article>

            <article className="foody-card">
              <h3>{t("orbisSupport.contactDetails.title")}</h3>
              <p>{t("orbisSupport.contactDetails.subtitle")}</p>
              <ul className="support-list">
                {contactItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("orbisSupport.commonIssues.title")}</h3>
              <ul className="support-list">
                {issues.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="foody-card">
              <h3>{t("orbisSupport.links.title")}</h3>
              <p>
                <a href="https://wodaslabs.com">
                  {t("orbisSupport.links.home")}
                </a>
              </p>
              <p>
                <a href="https://wodaslabs.com/apps/orbislines/static/privacy">
                  {t("orbisSupport.links.privacy")}
                </a>
              </p>
              <p>
                <a href="https://wodaslabs.com/apps/orbislines/static/terms">
                  {t("orbisSupport.links.terms")}
                </a>
              </p>
            </article>
          </div>
        </section>

        <section className="foody-cta">
          <div>
            <h2>{t("orbisSupport.footer.title")}</h2>
            <p>
              {t("orbisSupport.footer.desc")}
              <br />
              <a href="mailto:support-orbislines@wodaslabs.com">
                support-orbislines@wodaslabs.com
              </a>
            </p>
          </div>
          <div className="store-badges foody-store-badges">
            <a
              className="btn primary"
              href="mailto:support-orbislines@wodaslabs.com"
            >
              {t("orbisSupport.footer.emailButton")}
            </a>
          </div>
        </section>
      </main>
    </div>
  );
};

export default OrbisLinesSupportPage;
